import React, {Component} from 'react';
import css from '../login/login.scss';
import gql from 'graphql-tag';
import {Mutation} from 'react-apollo';

const REGEN_PASSWORD = gql`
	mutation($token: String!, $newPassword: String!) {
		resetPassword(token: $token, newPassword: $newPassword)
	}
`;

class ResetPassword extends Component {
	state = {
		newPassword: '',
		success: false,
	};
	updateState = e => {
		let state = {};
		state[e.target.name] = e.target.value;
		this.setState(_ => state);
	};
	checkPasswords = e => {
		if (this.state.newPassword !== e.target.value) {
			e.target.setCustomValidity(
				'Les mots de passe ne correspondent pas',
			);
		} else {
			e.target.setCustomValidity('');
		}
	};
	oncePasswordChanged = ({resetPassword}) => {
		if (resetPassword) {
			this.setState(_ => ({success: true}));
		}
	};
	render() {
		return (
			<Mutation
				mutation={REGEN_PASSWORD}
				variables={{
					newPassword: this.state.newPassword,
					token: this.props.match.params.token,
				}}
				update={this.updateCache}
				onCompleted={this.oncePasswordChanged}
			>
				{(resetPassword, {data, loading, error}) => {
					return !this.state.success ? (
						<form
							className={css.form}
							onSubmit={e => {
								e.preventDefault();
								resetPassword();
							}}
						>
							<h1 className={css.h1}>
								Réinitialisation du mot de passe
							</h1>
							<input
								type="password"
								placeholder="Nouveau mot de passe"
								className={css.input}
								name="newPassword"
								onChange={this.updateState}
								value={this.state.newPassword}
								required
								disabled={loading}
							/>
							<input
								type="password"
								placeholder="Répétez le nouveau mot de passe"
								className={css.input}
								onChange={this.checkPasswords}
								required
								disabled={loading}
							/>
							{error && (
								<div className={css.error}>
									{error.graphQLErrors[0]}
								</div>
							)}
							<button
								type="submit"
								className={css.button}
								disabled={loading}
							>
								Valider
							</button>
						</form>
					) : (
						<div className={css.form}>
							<p>
								Votre nouveau mot de passe a bien été
								généré&nbsp;!
							</p>
							<p>
								Vous pouvez désormais vous connecter à votre
								application.
							</p>
							{/* <button
								className={css.button}
								onClick={_ => {
									window.open(window.location, '_self').close();
								}}
							>
								Fermer
							</button> */}
						</div>
					);
				}}
			</Mutation>
		);
	}
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/resetPassword/resetPassword.js